import { h } from 'preact';
import { useState } from 'preact/hooks';
import { IconBrandChrome, IconBrandEdge, IconBrandFirefox, IconBrandGithub, IconMenu2, IconX } from '@tabler/icons';
import { m as motion } from 'framer-motion';
import { useLockBodyScroll } from 'react-use';

import Logo from '../Logo/Logo';
import Button, { ButtonIcon } from '../Button/Button';
import { getBrowser } from '../../utils';
import * as urls from '../../urls';
import colors from 'tailwindcss/colors';
import { useBreakpoint } from '../../hooks';

function Header({ theme }) {
  const browser = getBrowser();
  const [mobileNav, setMobileNav] = useState(false);
  const bp = useBreakpoint();

  useLockBodyScroll(mobileNav);

  let DownloadButton = null;
  if (typeof window !== 'undefined') {
    switch(browser) {
      case 'Firefox':
        DownloadButton = (
          <Button as="a" href={urls.FIREFOX_ADDON}>
            <ButtonIcon>
              <IconBrandFirefox />
            </ButtonIcon>
            Download
          </Button>
        );
        break;
      case 'Edge':
        DownloadButton = (
          <Button as="a" href={urls.EDGE_ADDON}>
            <ButtonIcon>
              <IconBrandEdge />
            </ButtonIcon>
            Download
          </Button>
        );
        break;
      default:
        DownloadButton = (
          <Button as="a" href={urls.CHROME_WEB_STORE}>
            <ButtonIcon>
              <IconBrandChrome />
            </ButtonIcon>
            Download
          </Button>
        );
        break;
    }
  }

  return (
    <motion.div
      class="border-t-4 border-purple-600 fixed top-0 left-0 right-0 bg-gray-50 bg-opacity-90 md:bg-transparent z-20"
      initial={{ color: colors.coolGray[900] }}
      animate={{ color: theme === 'dark' ? colors.coolGray[50] : colors.coolGray[900] }}
      transition={{ duration: 0.8, delay: 0 }}
    >
      <header class="flex justify-between items-center container mx-auto px-8 py-6 lg:px-32 md:py-6 relative z-10">
        <a href="/">
          <Logo className="hover:text-purple-600" />
        </a>
          <nav class="hidden md:flex font-semibold items-center space-x-12 tracking-tight">
            <a href="https://github.com/blenderskool/untab" class="transition-colors hover:text-purple-600 py-4 flex items-center">
              <IconBrandGithub size={20} />
              <span class="inline-block ml-1">GitHub</span>
            </a>
            {DownloadButton}
          </nav>
          <button onClick={() => setMobileNav(x => !x)} class="md:hidden p-2 hover:text-purple-600 transition-colors focus:outline-none focus:ring ring-purple-500 ring-opacity-25 rounded">
            {mobileNav ? <IconX size={26} /> : <IconMenu2 size={26} />}
          </button>
      </header>
      
      {/* Mobile menu */}
      {
        !bp.md && (
          <motion.nav
            class="flex flex-col justify-center space-y-4 fixed inset-0 top-1 p-8 pt-24 z-0 font-semibold border-b-4 border-purple-600 bg-gray-50"
            initial={{ y: '-100%', backgroundColor: colors.coolGray[50] }}
            animate={{ y: mobileNav ? 0 : '-100%', backgroundColor: theme === 'dark' ? colors.coolGray[900] : colors.coolGray[50] }}
            transition={{ type: 'spring', duration: 0.5 }}
          >
            <a href="https://github.com/blenderskool/untab" class="transition-colors hover:text-purple-600 p-4 -ml-4 flex items-center group">
              <IconBrandGithub size={20} />
              <span class="inline-block ml-1 transition-transform transform group-hover:translate-x-1.5">GitHub</span>
            </a>
            <a href={urls.CHROME_WEB_STORE} class="transition-colors hover:text-purple-600 p-4 -ml-4 flex items-center group">
              <IconBrandChrome size={20} />
              <span class="inline-block ml-1 transition-transform transform group-hover:translate-x-1.5">Download for Chrome</span>
            </a>
            <a href={urls.FIREFOX_ADDON} class="transition-colors hover:text-purple-600 p-4 -ml-4 flex items-center group">
              <IconBrandFirefox size={20} />
              <span class="inline-block ml-1 transition-transform transform group-hover:translate-x-1.5">Download for Firefox</span>
            </a>
            <a href={urls.EDGE_ADDON} class="transition-colors hover:text-purple-600 p-4 -ml-4 flex items-center group">
              <IconBrandEdge size={20} />
              <span class="inline-block ml-1 transition-transform transform group-hover:translate-x-1.5">Download for Edge</span>
            </a>
          </motion.nav>
        )
      }
    </motion.div>
  );
}

export default Header;
